import { DataLabelEnum } from '../../../../model/data_label.enum';
import { GetVolProvider } from '../../../../providers/get-vol-provider';
import { VolCompareProvider } from '../../../../providers/widgets';
import { IVolatilitySmileComparisonProps } from '../volatility-smile-comparison/types';
import VolatilitySmileComparisonWidget from './term-structure-comparison-widget';

const TermStructureComparisonWrapperProvider = (props: IVolatilitySmileComparisonProps) => {
  return (
    <GetVolProvider label={DataLabelEnum.PERPETUAL} providerKey={props.providerKey}>
      <VolCompareProvider isTermStructure providerKey={props.providerKey}>
        <VolatilitySmileComparisonWidget {...props} />
      </VolCompareProvider>
    </GetVolProvider>
  );
};

export default TermStructureComparisonWrapperProvider;
